import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import type { Props } from "./account-navigation";

import { AccountNavigationItem } from "./account-navigation-item";
import { getMenuItems } from "./helpers/menu-items";
import { useIsAuthenticated } from "./use-is-authenticated";

export const AccountNavigationMdUp: React.FC<Props> = ({ current_page }) => {
  const { translator, urlBuilder } = useAppContext();
  const is_authenticated = useIsAuthenticated();

  const items = getMenuItems(translator, urlBuilder, is_authenticated);

  return (
    <div className="hidden flex-col sm:flex">
      {items.map(item => (
        <AccountNavigationItem
          key={item.account_section}
          label={item.label}
          Icon={item.Icon}
          url={item.url}
          account_section={item.account_section}
          selected={item.isSelected(current_page)}
        />
      ))}
    </div>
  );
};
